<!--
 * @Author: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @Date: 2023-12-23 11:30:15
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2023-12-23 11:43:40
 * @FilePath: \合联\oms\src\view\system\contractTitleAndAgreement\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
    <template #header>
      <Tabs type="card" v-model="tabName" @on-click="handleTab">
        <TabPane
          v-for="(item, idx) in tabList"
          :key="idx"
          :label="item.label"
          :name="item.value"
        />
      </Tabs>
    </template>
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/system/contractTitleAndAgreement.js";
export default {
  name: "contractTitleAndAgreement",
  components: {
    cTable
  },
  methods: {
    handleTab(tab) {
      this.tabName = tab;
      this.$refs["table"].pageConfig.page = 1;
      this.$refs["table"].pageConfig.size = 15;
      this.$refs["table"].resize();
      this.$refs["table"].getList();
    }
  },
  data() {
    return {
      tabList: [
        {
          label: this.$tz("合同抬头"),
          value: "1"
        },
        {
          label: this.$tz("合同协议"),
          value: "2"
        }
      ],
      tabName: "1",
      methods: {
        ...apis,
        list: p => {
          p.type = this.tabName;
          return apis.list(p);
        },
        beforeHandleList({ data }) {
          return data;
        }
      },
      config: {},
      footer: {
        show: () => false
      },
      modals: {},
      header: {
        searchs: [],
        btns: {
          list: [],
          methods: {}
        }
      },
      fields: [
        {
          name: () => this.$tz("名称"),
          key: "title",
          minWidth: 130
        },
        {
          name: () => this.$tz("公司名,-,中文"),
          key: "company_name_cn",
          minWidth: 130,
          show: () => this.tabName === "1"
        },
        {
          name: () => this.$tz("公司名,-,英文"),
          key: "company_name_en",
          minWidth: 130,
          show: () => this.tabName === "1"
        },
        {
          name: () => this.$tz("公司,地址,-,中文"),
          key: "company_address_cn",
          minWidth: 130,
          show: () => this.tabName === "1"
        },
        {
          name: () => this.$tz("公司,地址,-,英文"),
          key: "company_address_en",
          minWidth: 130,
          show: () => this.tabName === "1"
        },
        {
          name: () => this.$tz("联系电话"),
          key: "company_tel",
          minWidth: 130,
          show: () => this.tabName === "1"
        },
        {
          name: () => this.$tz("邮箱"),
          key: "company_email",
          minWidth: 130,
          show: () => this.tabName === "1"
        },
        {
          name: () => this.$tz("收款,银行"),
          key: "bank_name",
          minWidth: 130,
          show: () => this.tabName === "1"
        },
        {
          name: () => this.$tz("银行卡号"),
          key: "bank_number",
          minWidth: 130,
          show: () => this.tabName === "1"
        },
        {
          name: () => this.$tz("银行账户"),
          key: "bank_account",
          minWidth: 130,
          show: () => this.tabName === "1"
        },
        {
          name: () => this.$tz("支付宝支付,APPID"),
          key: "alipay_app_id",
          minWidth: 130,
          show: () => this.tabName === "1"
        },
        {
          name: () => this.$tz("公司名称,简称"),
          key: "short_title",
          minWidth: 130,
          show: () => this.tabName === "1"
        },
        {
          name: () => this.$tz("微信支付,APPID"),
          key: "wx_app_id",
          minWidth: 130,
          show: () => this.tabName === "1"
        }
      ]
    };
  }
};
</script>

<style scoped></style>
